export const preloadImages = async (images: string[]): Promise<void> => {
  try {
    const loadImage = (src: string): Promise<void> =>
      new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve()
        img.onerror = () => reject()
        img.src = src
      })
    await Promise.all(images.map((src) => loadImage(src)))
  } catch {
    // eslint-disable-next-line no-useless-return
  }
}
